import { rankItem } from '@tanstack/match-sorter-utils';

export const fuzzyFilter = (row, columnId, value) =>
  rankItem(row.getValue(columnId), value).passed;
